import AverageLeadTime from './AverageLeadTime';

export default AverageLeadTime;
